import styled, { createGlobalStyle } from 'styled-components';
const appColor = sessionStorage.getItem('appColor');
export const primary = appColor ? appColor : '#f02c3c';
export const secondary = '#fbfee5';
export const gray = '#b3b4b6';

// DEPRECATED

export const GlobalStyle = createGlobalStyle`
    body {
        // font-family: 'Open Sans';
    }
    #mr-main{
      display: flex;
      flex-direction: column;
      height: 100%;
      max-height: 100%;
      overflow: hidden;
      box-sizing: border-box;
      background-color: rgba(0, 0, 0, 0.5);
        .MuiDialog-container {
            * {
              box-sizing: border-box;
            }
            :focus-visible {
              box-shadow: none;
            }
            ${props => (props.isSlideOut ? `position: fixed` : null)};
            ${props => (props.isSlideOut ? `right: 0` : null)};
            ${props => (props.isSlideOut ? `bottom: 0` : null)};
            ${props =>
              props.isSlideOut ? `align-items: flex-end !important` : null};
            
            @media (max-width: 430px) {
              ${props => (props.isSlideOut ? `position: initial` : null)};
            }
            
        }
        .MuiDialog-paperFullWidth {
            border-top-left-radius: ${props => props.popupBorderRadius}px;
            border-top-right-radius: ${props => props.popupBorderRadius}px;
            border-bottom-left-radius: ${props =>
              props.isSlideOut ? '0' : props.popupBorderRadius}px;
            border-bottom-right-radius: ${props =>
              props.isSlideOut ? '0' : props.popupBorderRadius}px;
            margin: 0;
            height: ${props => props.popupHeight};
            max-width: ${props => props.popupWidth};
            width: ${props => props.popupWidth};
            @media (max-width: 430px) {
              width: 100%;
              border-top-left-radius: ${props =>
                props.popupMobileBorderRadius}px;
              border-top-right-radius: ${props =>
                props.popupMobileBorderRadius}px;
              border-bottom-left-radius: ${props =>
                props.isSlideOut ? '0' : props.popupMobileBorderRadius}px;
              border-bottom-right-radius: ${props =>
                props.isSlideOut ? '0' : props.popupMobileBorderRadius}px;
            }
        }
        z-index: 2147483648 !important;
        #scroll-dialog-title, #scroll-dialog-description {
            padding: 0;
        }
        #scroll-dialog-description{
          flex-grow: 1;
          min-height: fit-content;
          overflow: auto;
          background-color: ${props => props.offerBackgroundColor};
          ::-webkit-scrollbar {
            width: 7px;
            height: 7px;
            background-color: transparent;
          }
          ::-webkit-scrollbar-corner {
            background-color: transparent;
            border-color: transparent;
          }
          ::-webkit-scrollbar-thumb {
            border-radius: 7px;
            background-color: #c4c4c4;
          }
          ::-webkit-scrollbar-track {
            border-radius: 7px;
            background-color: transparent;
          }
          @media (max-width: 768px) {
            ::-webkit-scrollbar {
              width: 4px;
              height: 4px;
            }
            ::-webkit-scrollbar-thumb {
              border-radius: 4px;
            }
            ::-webkit-scrollbar-track {
              border-radius: 4px;
            }
          }
        }
        .bottom{
          padding: 10px;
          background-color: ${props => props.offerBackgroundColor};
          flex-direction: column;
          // padding-left: 1.5rem;
          // padding-right: 1.5rem;

          .checkout {
            min-width: ${props =>
              props.bottomBarButtonWidthStyle === 'fitContent'
                ? 'calc(50% - 6px)%'
                : '100%'};
            min-height: ${props => props.bottomBarButtonHeight}px;   
            flex-grow: 1;
            text-transform: unset;
            font-size: ${props => props.bottomBarButtonFontSize}px;
            font-family: ${props => props.font};
            background-color: ${props =>
              props.bottomBarButtonStyle === 'filled'
                ? props.bottomBarButtonColor
                : 'transparent'};
            color: ${props => props.bottomBarButtonTextColor};
            text-decoration: ${props => props.bottomBarButtonTextDecoration};
            font-style: ${props => props.bottomBarButtonFontStyle};
            font-weight: ${props => props.bottomBarButtonFontWeight};
            @media (max-width: 425px) {
              font-size: ${props => props.bottomBarButtonMobileFontSize}px;
            }

            @media (max-width: 360px) {
              right: 0;
            }

            &:hover {
              background-color: ${props =>
                props.bottomBarButtonStyle === 'filled'
                  ? props.bottomBarButtonColor
                  : 'transparent'};
            }
            border: 1px solid;
            border-color: ${props =>
              props.bottomBarButtonStyle !== 'text'
                ? props.bottomBarButtonColor
                : 'transparent'};
            border-radius: ${props => props.bottomBarButtonBorderRadius}px;
          }

            .checkout-atc {
              min-width: calc(50% - 6px);
              flex-grow: 1;
              text-transform: unset;
              font-size: 1em;
              padding: 0.75em 1em;
              color: ${props =>
                props.productButtonColor ? props.productButtonColor : primary};
              border-color: ${props =>
                props.productButtonColor ? props.productButtonColor : primary};
              font-family: ${props => props.font};
              @media (max-width: 360px) {
                right: 0;
              }
            }
            .skip{
              box-shadow: none;
              flex-grow: 1;
              min-width: ${props =>
                props.bottomBarSecondaryButtonWidthStyle === 'fitContent'
                  ? 'calc(50% - 6px)'
                  : '100%'};
              min-height: ${props => props.bottomBarSecondaryButtonHeight}px;
              font-size: ${props => props.bottomBarSecondaryButtonFontSize}px;
              padding: 0;
              text-transform: none;
              letter-spacing: 0.15px;
              color: ${props => props.bottomBarSecondaryButtonColor};
              font-family: ${props => props.font};
              background-color: ${props =>
                props.bottomBarSecondaryButtonStyle === 'filled'
                  ? props.bottomBarSecondaryButtonColor
                  : 'transparent'};

              border: 1px solid;
              border-color: ${props =>
                props.bottomBarSecondaryButtonStyle !== 'text'
                  ? props.bottomBarSecondaryButtonColor
                  : 'transparent'};
              border-radius: ${props =>
                props.bottomBarSecondaryButtonBorderRadius}px;
              text-decoration: ${props =>
                props.bottomBarSecondaryButtonTextDecoration};
              font-style: ${props => props.bottomBarSecondaryButtonFontStyle};
              font-weight: ${props => props.bottomBarSecondaryButtonFontWeight};
              
              :hover {
                background-color: ${props =>
                  props.bottomBarSecondaryButtonStyle === 'filled'
                    ? props.bottomBarSecondaryButtonColor
                    : 'transparent'};

              }
              @media (max-width: 360px) {
                text-align: center;
              }
              @media (max-width: 425px) {
                font-size: ${props =>
                  props.bottomBarSecondaryButtonMobileFontSize}px;
              }
            }
            .cart {
              flex-grow: 1;
              min-width: calc(50% - 6px);
              letter-spacing: 0.15px;
              text-transform: inherit;
              padding-left: 2.5em;
              padding-right: 2.5em;
              font-family: ${props => props.font};
              font-size: ${props => props.bottomBarBackButtonFontSize}px;
              color: ${props => props.bottomBarBackButtonTextColor};
              border-color: ${props => props.productButtonTextColor};
              font-weight: ${props => props.bottomBarBackButtonFontWeight};
              font-style: ${props => props.bottomBarBackButtonFontStyle};
              text-decoration: ${props =>
                props.bottomBarBackButtonTextDecoration};
              @media (max-width: 425px) {
                font-size: ${props =>
                  props.bottomBarBackButtonMobileFontSize}px;
              }
            }
          }
    }
    #mr-main {
      .mr-close-icon {
        padding: 5px;
        cursor: pointer;
        position: absolute;
        top: 0.5rem;
        right: 0.5rem;
        @media (min-width: 425px) {
          top: 1rem;
          right: 1rem;
        }
      }

      .mr-minimise-icon {
        padding: 5px;
        cursor: pointer;
        position: absolute;
        top: 1rem;
        left: 1rem;
      }
    }
    #repeat{
        bottom: -60% !important;
        left: revert !important;
        z-index: 2147483648 !important;
        height: 800px;
        width: 500px;
        @media (max-width: 768px) {
          height: 100%;
        }
        @media (max-width: 425px) {
            left: 0 !important;
        }
        .MuiDialog-paperWidthXs{
            bottom: -31%;
        }
            .MuiDialogContent-root{
                padding: 20px;
            .title{
                font-style: normal;
                font-weight: 600;
                font-size: 16px;
                line-height: 24px;
                display: flex;
                align-items: center;
                letter-spacing: 0.15px;
                color: #222F3E;
            }
        .subtitle{
            font-style: normal;
            font-weight: 600;
            font-size: 12px;
            line-height: 20px;
            display: flex;
            align-items: center;
            letter-spacing: 0.15px;
            color: rgba(34, 47, 62, 0.5);
            margin-bottom: 20px;
        }
        .black{
            border: 1px solid #000000;
            box-sizing: border-box;
            border-radius: 6px;
            width: 160px;
            @media (max-width: 425px) {
                padding: 5px 10px;
                width: 48%;
            }
            @media (max-width: 320px) {
                width: auto;
            }
        }
        .red{
            border: 1px solid ${props =>
              props.bottomBarButtonColor
                ? props.bottomBarButtonColor
                : primary};;
            box-sizing: border-box;
            border-radius: 6px;
            color: ${props =>
              props.bottomBarButtonColor
                ? props.bottomBarButtonColor
                : primary};;
            float: right;
            width: 160px;
            @media (max-width: 425px) {
                padding: 5px 10px;
                width: 48%;
            }
            @media (max-width: 320px) {
                width: auto;
            }
        }
    }
  }
`;

export const MainDiv = styled.div`
  font-size: 16px;
  * {
    font-family: ${props => (props.topBarFont ? props.topBarFont : 'inherit')};
  }

  .timer {
    background-color: ${props =>
      props.topBarBackgroundColor ? props.topBarBackgroundColor : secondary};
    // this did not work so used the below paragraph to give color
    color: ${props =>
      props.topBarTextColor ? props.topBarTextColor : 'inherit'};
    letter-spacing: normal;
    .span {
      position: absolute;
      top: 20px;
      text-align: center;
      margin: 0;
      left: 36%;
      text-transform: uppercase;
      font-weight: 600;
      font-size: 13px;
    }
    .paragraph {
      text-transform: none;
      text-align: center;
      width: 100%;
      margin-bottom: 8px;
      margin-top: 8px;
      color: ${props =>
        props.topBarTextColor ? props.topBarTextColor : 'inherit'};
    }

    .p {
      background-color: ${props => props.offerBackgroundColor};
      position: absolute;
      left: 0;
      bottom: 0;
      text-transform: none;
      font-weight: normal;
      font-size: 11px;
      width: 100%;
      padding: 20px;
      margin: 0;
      .img {
        vertical-align: middle;
        width: 14px;
        display: inline;
      }
      span {
        cursor: pointer;
      }
    }
  }
`;

export const StyledDiv = styled.div`
  height: auto;
  ${props =>
    props.showProductDesciption
      ? `box-shadow: 0 0 1em -0.5em rgb(0 0 0 / 50%);`
      : null}
  padding: ${props => props.padding};
  position: relative;
  overflow: hidden;
  .clock-con {
    line-height: 1;
    text-align: center;
    display: inline-flex;
    .red-box {
      display: inline-block;
      position: relative;
      padding: 7px;
      margin: 0 3.5px;
      width: 45px;
      height: 40px;
      border-radius: 20%;
      background: ${props =>
        props.topBarTimerColor ? props.topBarTimerColor : primary};
      .time {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        color: ${props =>
          props.topBarTimerTextColor ? props.topBarTimerTextColor : 'white'};
        text-align: center;
        margin: 0;
        font-size: 20px;
        font-weight: 600;
        word-break: normal;
      }
    }
  }
`;

export const Advertisement = styled(StyledDiv)`
  * {
    font-family: ${props => (props.topBarFont ? props.topBarFont : 'inherit')};
    }

    display: flex;
    flex-direction: row;
    align-items: center;
    border-radius: ${props => props.borderRadius};
    background-color: ${props => props.floatingBackgroundColor};
    cursor: pointer;
    position: fixed;
    bottom: ${props => props.bottom};
    right: 10px;
    z-index: 2147483648 !important;
    width: auto;
    height: auto;
    padding: 4px;
    
    box-shadow: 0px 11px 15px -7px rgb(0 0 0 / 20%),
    0px 24px 38px 3px rgb(0 0 0 / 14%), 0px 9px 46px 8px rgb(0 0 0 / 12%);

    .offer-title {
      padding: 2px;
      padding-top: 0;
      padding-bottom: 0;
      color: ${props => props.floatingTextColor};
      font-size: ${props => props.floatingFontSize}px;
      font-weight: ${props => props.floatingFontWeight};
      font-style: ${props => props.floatingFontStyle};
      text-decoration: ${props => props.floatingTextDecoration};
      @media (max-width: 425px) {
        font-size: ${props => props.floatingMobileFontSize}px;
      }
      
    }

    .percent-vector{
      height: 30px;
      width: 30px;
    }

    .closepopup {
      fill: ${props => props.floatingTextColor};
        font-size: 14px;
        cursor: pointer;
    }

  }
`;

export const BundleOfferBlock = styled.div`
  display: flex;
  margin: 0;
  padding: 0.75em 1.5em;
  justify-content: space-between;
  align-items: center;
  border: 0;
  border-top: 1px solid #d1d1d1;
  border-bottom: 1px solid #d1d1d1;
  color: #222f3e;
  .row-definition {
    font-weight: ${props => props.bundleTaglineFontWeight};
    text-decoration: ${props => props.bundleTaglineTextDecoration};
    font-style: ${props => props.bundleTaglineFontStyle};
    font-size: ${props => props.bundleTaglineFontSize}px;
    @media (max-width: 425px) {
      font-size: ${props => props.bundleTaglineMobileFontSize}px;
    }
    color: ${props => props.bundleTaglineTextColor};
    max-width: 40%;
    padding-right: 0.5em;
    line-height: 1.5;
    @media (max-width: 400px) {
      max-width: 35%;
    }
  }
  .row-value {
    font-weight: normal;
    .original-amt {
      color: ${props => props.productPriceTextColor};
      font-weight: bold;
      font-size: ${props => props.productPriceFontSize}px;
    }
    .offered-amt {
      .total-price {
        text-decoration: line-through;
        padding-right: 0.5rem;
        font-size: ${props => props.productPriceFontSize}px;
        color: ${props => props.productPriceTextColor}80;
      }
      .discount-value-type {
        color: ${props => props.productDiscountTextColor};
        font-size: ${props => props.productDiscountFontSize}px;
        font-weight: ${props => props.productDiscountFontWeight};
        font-style: ${props => props.productDiscountFontStyle};
        text-decoration: ${props => props.productDiscountTextDecoration};
        @media (max-width: 425px) {
          font-size: ${props => props.productDiscountMobileFontSize}px;
        }
      }
    }
  }
`;

export const CheckoutCon = styled.div`
  display: flex;
  flex-direction: row-reverse;
  flex-wrap: wrap;
  gap: 12px;
  justify-content: space-between;
  padding: 16px;
  font-size: 10px;

  & > * {
    flex-basis: calc(50% - 6px);
    min-width: max-content !important;
  }

  .skip {
    color: ${props => props.bottomBarSecondaryButtonTextColor} !important;
  }

  @media (max-width: 360px) {
    margin-left: 0 !important;
  }
`;

export const Middle = styled.div`
  * {
    font-family: ${props =>
      props.productFont ? props.productFont : 'inherit'};
  }

  tr:first-child td:after,
  tr:first-child th:after {
    border: none;
  }

  overflow: hidden;
  padding: 0 20px;

  .mrProductTable {
    border: none;
    background: none;
    white-space: normal;
    ${props =>
      props.isBundled
        ? `width: 100%;
    display: table;
    border-collapse: separate;`
        : null};
  }

  .mr-product {
    font-family: inherit;
    background-color: ${props => props.offerBackgroundColor};
    padding-top: 20px;
    padding-bottom: 20px;
    padding-right: 0;
    padding-left: 0;
    border: none;
    ${props =>
      props.isBundled
        ? null
        : `border-bottom: 1px solid rgba(34, 47, 62, 0.2)`};
    }
    #Gpic2 {
      text-align: center;
      .sliderImg {
        height: 270px;
        border-radius: 12px;
        margin: 0px auto;
        width: auto;
      }
    }
    .desc {
      position: relative;
    }
  }
  .expanded {
    .mr-product {
      font-family: inherit;
      .p {
        font-weight: normal;
        font-size: 11px;
        position: absolute;
        top: 132px;
        z-index: 99;
        background: white;
        width: 100%;
        padding: 20px;
        left: 0;
        @media (max-width: 425px) {
          top: 128px;
        }
        .img {
          vertical-align: bottom;
        }
      }
      .heading {
        cursor: pointer;
        font-size: ${props => props.productNameFontSize}px;
        color: ${props => props.productNameTextColor};
        font-weight: ${props => props.productNameFontWeight};
        font-style: ${props => props.productNameFontStyle};
        text-decoration: ${props => props.productNameTextDecoration};
        @media (max-width: 425px) {
          font-size: ${props => props.productNameMobileFontSize}px;
        }
      }
      .paragraph {
        margin-top: 0;
      }
      .hr {
        border: none;
        height: 1px;
        background: rgba(34, 47, 62, 0.2);
        margin: 12px auto;
      }
      .mr-product-description-text {
        position: relative;
        display: block;
        span {
          background-color: ${props => props.offerBackgroundColor};
          font-size: ${props => props.productDescriptionFontSize}px;
          color: ${props => props.productDescriptionTextColor};
          font-weight: ${props => props.productDescriptionFontWeight};
          font-style: ${props => props.productDescriptionFontStyle};
          text-decoration: ${props => props.productDescriptionTextDecoration};
          @media (max-width: 425px) {
            font-size: ${props => props.productDescriptionMobileFontSize}px;
          }
          padding-right: 2em;
          position: relative;
          z-index: 1;
        }
        &:after {
          content: "";
          width: 100%;
          height: 1px;
          background: rgba(34, 47, 62, 0.2);
          right: 0;
          top: 50%;
          transform: translateY(-50%);
          position: absolute;
          z-index: 0;
        }
      }
      .description {
        margin-top: 16px;
        h1,
        h2,
        h3,
        h4 {
          font-size: 14px;
        }
        div,
        p {
          color: rgba(34, 47, 62, 0.5);
          font-size: 12px;
        }
      }
    }
  }
  .mr-product-td {
    ${props =>
      props.isBundled
        ? `position: relative;
    padding: 1em;
    border: 0;`
        : null};
  }
  .variants {
    position: relative;
    right: 0;
    display: inline-block;
  }
  .MuiTableContainer-root {
    overflow: hidden;
  }
  .MuiPaper-elevation1 {
    box-shadow: none;
  }
  .small {
    color: ${gray};
  }
  .image {
    border-radius: 5px;
  }
  .heading {
    font-size: ${props => props.productNameFontSize}px;
    color: ${props => props.productNameTextColor};
    font-weight: ${props => props.productNameFontWeight};
    font-style: ${props => props.productNameFontStyle};
    text-decoration: ${props => props.productNameTextDecoration};
    @media (max-width: 425px) {
      font-size: ${props => props.productNameMobileFontSize}px;
    }
    margin-bottom: 5px;
    .img {
      position: absolute;
      right: ${props => (props.isBundled ? '-4' : '8')}px;
      top: 5px;
      cursor: pointer;
      width: 8px;
    }
  }
  .paragraph {
    font-family: inherit;
    margin-bottom: 0;
    @media (max-width: 425px) {
      ${props => (props.isBundled ? 'margin-bottom: 12px;' : null)};
    }
    .discount {
      font-size: ${props =>
        props.isAdmin && props.isAdminMobileTab
          ? props.productPriceMobileFontSize
          : props.productPriceFontSize}px;
      text-decoration: ${props =>
        props.isPriceStrikeThrough ? 'line-through' : 'none'};
      color: ${props => props.productPriceTextColor}80;

      @media (max-width: 430px) {
        font-size: ${props => props.productPriceMobileFontSize}px;
      }
    }
    
    .disc-percent {
      color: ${props => props.productDiscountTextColor};
      font-size: ${props => props.productDiscountFontSize}px;
      font-weight: ${props => props.productDiscountFontWeight};
      font-style: ${props => props.productDiscountFontStyle};
      text-decoration: ${props => props.productDiscountTextDecoration};
      @media (max-width: 425px) {
        font-size: ${props => props.productDiscountMobileFontSize}px;
      }
    }
  }
  .mr-number {
    border: 1px solid
      ${props =>
        props.productButtonColor ? props.productButtonColor : primary};
    border-radius: 5px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    .minus,
    .plus {
      display: inline-flex;
      justify-content: center;
      align-items: center;
      padding: 4px 8px;
      color: ${props =>
        props.productButtonColor ? props.productButtonColor : primary};
      min-width: 33%;
      cursor: pointer;
      @media (max-width: 425px) {
        padding: 4px;
        height: 23px;
      }
      .svg {
        font-size: 15px;
        cursor: pointer;
      }
    }
    .counter {
      text-align: center;
      font-size: 13px;
      color: ${props => props.productButtonColor};
      display: inline-block;
      vertical-align: middle;
      font-weight: 600;
      @media (max-width: 425px) {
        font-weight: 100;
      }
    }
  }
  .add {
    text-transform: none;
    border-color: ${props =>
      props.productButtonColor ? props.productButtonColor : primary};
    color: ${props =>
      props.productButtonColor ? props.productButtonColor : primary};
    // width: 81px;
    :hover {
      background-color: transparent;
      border-color: rgb(0, 0, 0);
    }
    @media (max-width: 768px) {
      font-size: 10px;
    }
  }
  .MuiAccordionSummary-expandIcon {
    margin-top: -118px !important;
  }
  .view {
    font-weight: 600;
    font-size: 12px;
    letter-spacing: 0.15px;
    color: ${props => props.productVariantTextColor};
    margin: 2px 4px;
    padding: 2px 8px;
    border-radius: 10px;
    display: inline-block;
    border: 1px solid ${props => props.productVariantColor};
  }
  .price {
    color: ${props => props.productPriceTextColor};
    font-weight: bold;
    font-size: ${props =>
      props.isAdmin && props.isAdminMobileTab
        ? props.productPriceMobileFontSize
        : props.productPriceFontSize}px;
    display: inline;

    @media (max-width: 425px) {
      font-size: ${props => props.productPriceMobileFontSize}px;
    }
  }
  &.div__responsive {
    font-size: 14px;

    padding: 0em 1em;

    // added is bundled condition as crossell in mobile view was broken

    .tableCell-root {
      font-size: 1em;
    }
    .MuiInputBase-root {
      font-size: 1em;
    }
    .mr-product-td {
      .heading {
        margin: 0;
        font-size: ${props => props.productNameFontSize}px;
        color: ${props => props.productNameTextColor};
        font-weight: ${props => props.productNameFontWeight};
        font-style: ${props => props.productNameFontStyle};
        text-decoration: ${props => props.productNameTextDecoration};
        @media (max-width: 425px) {
          font-size: ${props => props.productNameMobileFontSize}px;
        }
        cursor: pointer;
      }
      .paragraph {
        align-items: center;
        margin-top: 0.25em;
        
        .selected-variant {
          font-size: 1em;
          margin: 0.25em 0 0;
          letter-spacing: 0.5px;
        }
        .added-to-cart-con {
          .added-to-cart {
            display: inline-block;
            text-align: center;
            font-size: ${props => props.addedToCartFontSize}px;
            color: ${props => props.addedToCartTextColor};
            font-weight: ${props => props.addedToCartFontWeight};
            font-style: ${props => props.addedToCartFontStyle};
            text-decoration: ${props => props.addedToCartTextDecoration};
            @media (max-width: 425px) {
              font-size: ${props => props.addedToCartMobileFontSize}px;
            }
            cursor: default;
            letter-spacing: 0.5px;
          }

          .added-to-cart-icon {
            transform: scale(2);
          }
        }
      }
      .desc {
        padding-left: 1em;
      }
    }
  }
  .requirements {
    .mr-select-variant {
      font-size: ${props => props.variantDropdownMobileFontSize}px;
      @media (max-width: 425px) {
        font-size: ${props => props.variantDropdownMobileFontSize}px;
      }
      min-height: ${props => props.productVariantHeight}px;
      padding: 0.6em 0.2em;
      padding-right: 30px;
      width: 100%;
      text-align: center;
      color: ${props => props.productVariantTextColor};
      border: 1px solid;
      border-color: ${props =>
        props.productVariantStyle === 'text'
          ? 'transparent'
          : props.productVariantColor};
      border-radius: ${props => props.productVariantBorderRadius}px;    
      background-color: ${props =>
        props.productVariantStyle === 'filled'
          ? props.productVariantColor
          : 'transparent'} !important;

      margin-bottom: 0px;
      :hover {
        outline: none;
      }
      :focus {
        outline: none;
        box-shadow: none;
      }
      :focus-visible {
        outline: none;
        box-shadow: none;
      }

      appearance: none;
      -webkit-appearance: none;
      -moz-appearance: none;
      -ms-appearance: none;
      background-position: calc(100% - 12px) center !important;
      background: url("data:image/svg+xml,<svg height='10px' width='10px' viewBox='0 0 16 16' fill='${props =>
        props.productVariantTextColor.replace(
          '#',
          '%23',
        )}' xmlns='http://www.w3.org/2000/svg'><path d='M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z'/></svg>")
        no-repeat;
    }

    display: inline-flex;
    flex-grow: 1;
    min-width: ${props =>
      props.isProductDescription
        ? 'calc(50% - 6px)'
        : props.isBundled
          ? '100%'
          : 'calc(50% - 6px)'};
    position: relative;
    letter-spacing: 1px;
    text-align: center;
    * {
      border: 0;
    }
    .click-through-con {
      width: 100%;
      .product-options-con {
        position: absolute;
        width: 100%;
        left: 0;
        top: 0;
      }
    }
    .MuiOutlinedInput-root {
      ${props =>
        props.isBundled ? null : 'font-size: 12px;'} display: inline-flex;
      width: 100%;
      fieldset {
        border: none;
      }
      > svg {
        top: 50%;
        transform: translateY(-50%);
      }
      > div {
        font-size: 0.75em;
        border: 0;
        padding: 0.5em 1em;
        padding-right: calc(0.5em + 20px);
        border-radius: 2px;
        letter-spacing: 1px;
        text-align: center;
        img {
          width: 12px;
          height: auto;
        }
      }
    }
  }
  .variant-desc {
    width: 100%;
    .MuiOutlinedInput-root {
      > div {
        font-size: 12px !important;
        line-height: 1;
      }
    }
  }
  .requirements.bundled {
    .mr-select-variant {
      padding: 0.6em 0.2em;
      padding-right: 30px;
      width: 100%;
      text-align: center;
      background-color: transparent;
      margin-bottom: 0px;
      border-color: ${props => props.productVariantColor};
      color: ${props => props.productVariantTextColor};
      :hover {
        outline: none;
      }
      :focus {
        outline: none;
        box-shadow: none;
      }
      :focus-visible {
        outline: none;
        box-shadow: none;
      }

      appearance: none;
      -webkit-appearance: none;
      -moz-appearance: none;
      -ms-appearance: none;
      background-position: calc(100% - 12px) center !important;
      background: url("data:image/svg+xml,<svg height='10px' width='10px' viewBox='0 0 16 16' fill='${props =>
        props.productVariantColor.replace(
          '#',
          '%23',
        )}' xmlns='http://www.w3.org/2000/svg'><path d='M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z'/></svg>")
        no-repeat;
      padding: 8px 32px 8px 16px;
    }
    min-height: auto;
    width: auto;
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 1em;
    * {
      border: 0;
    }
    @media (max-width: 425px) {
      margin-bottom: auto;
      margin-top: auto;
    }
    .MuiOutlinedInput-root {
      display: inline-flex;
      margin-right: 0.5em;
      width: auto;
      .MuiSelect-selectMenu {
        position: relative;
        ::after {
          content: "";
          background-image: url(${'https://resources.monkcommerce.app/app-images/down-arrow.svg'});
          position: absolute;
          right: 0.75em;
          top: 50%;
          transform: translateY(-50%);
          width: 1em;
          height: 1em;
          background-size: 1em 1em;
        }
      }
      > svg {
        display: none;
      }
      > div {
        font-size: 0.75em;
        border: 1px solid #1a1a1a;
        padding: 0.5em;
        padding-right: 2.25em;
        border-radius: 2px;
        letter-spacing: 1px;
      }
    }
  }
  .variant-desc {
    width: 100%;
    .MuiOutlinedInput-root {
      > div {
        font-size: 12px !important;
        line-height: 1;
      }
    }
  }
`;

export const HeaderTextCon = styled.div`
  margin: 0 !important;
  text-transform: none;
  font-size: 24px;
  text-align: center;
  color: ${props => props.offerHeaderTextColor};
  line-height: 2.5rem;
`;

export const DealHeaderText = styled.div`
  margin: 0 !important;
  font-size: ${props => props.offerHeaderFontSize}px;
  display: inline-block;
  color: ${props => props.offerHeaderTextColor} !important;
  font-weight: ${props => props.offerHeaderFontWeight};
  font-style: ${props => props.offerHeaderFontStyle};
  text-decoration: ${props => props.offerHeaderTextDecoration};
  letter-spacing: normal;
  @media (max-width: 425px) {
    font-size: ${props => props.offerHeaderMobileFontSize}px;
  }
`;

export const HeaderText = styled.div`
  margin: 0 !important;
  font-weight: bold;
  color: black;
  display: ${props => (props.isAdvertisement ? 'block' : 'inline-block')};
  ${props =>
    props.isAdvertisement
      ? `font-size: 11px;`
      : props.isTimerDisabled
        ? `font-size: 24px; line-height: 1.2;`
        : `font-size: 21px;`};
`;

export const PlusDiv = styled.div`
  position: relative;
  height: 1px;
  width: 100%;
  background-color: #d1d1d1;
  margin: 1.5em 0 1em;
  span {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    height: 2em;
    width: 4em;
    background-color: ${props => props.offerBackgroundColor};
    text-align: center;
    img {
      height: 100%;
      width: auto;
    }
  }
`;

export const RepeatButtonsCon = styled.div`
  .cancel-repeat {
    background-color: ${props => props.bottomBarButtonColor || primary};
  }
  .confirm-repeat {
    background-color: ${props => props.bottomBarButtonColor || primary};
  }
`;

export const ProductItemFooter = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  justify-content: ${props =>
    props.showVariantsSelector ? 'flex-start' : 'flex-end'};
  margin-top: ${props => (props.isBundled ? '8px' : '0')};
  .addBtn {
    display: inline-flex;
    flex-grow: ${props => (props.showVariantsSelector ? '1' : 'unset')};
    min-width: calc(50% - 6px);

    .mr-add {
      height: inherit;
      font-size: 1em;
      text-transform: none;
      width: 100%;
      border-color: ${props =>
        props.productButtonColor ? props.productButtonColor : primary};
      color: ${props =>
        props.productButtonColor ? props.productButtonColor : primary};

      :hover {
        background-color: transparent;
      }
    }

    .mr-icon {
      font-size: 1em;
      fill: currentColor;
    }
  }
`;

// export const VariantsCon = styled.div`
//   margin: 8px 0;
//   font-weight: normal;
// `;

export const VariantsCon = styled.div`
  margin: 8px 0px 0px 0px;
  font-weight: normal;
  text-align: start;
  text-transform: none;

  .variants {
    position: relative;
    right: 0;
    display: inline-block;
  }

  .view {
    font-weight: 600;
    font-size: 12px;
    letter-spacing: 0.15px;
    color: ${props => props.productVariantTextColor};
    margin: 2px 4px;
    padding: 2px 8px;
    border-radius: 10px;
    display: inline-block;
    border: 1px solid ${props => props.productVariantColor};
  }
`;

export const TimerDisplayCon = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  .timer-display-text {
    font-size: ${props => props.offerTitleFontSize}px;
    text-transform: none;
    padding-bottom: 4px;
    text-align: center;
    display: inline-flex;
    color: ${props => props.offerTitleTextColor};
    font-weight: ${props => props.offerTitleFontWeight};
    font-style: ${props => props.offerTitleFontStyle};
    text-decoration: ${props => props.offerTitleTextDecoration};

    @media (max-width: 425px) {
      font-size: ${props => props.offerTitleMobileFontSize}px;
    }
  }
`;

export const SeeProductDetails = styled.p`
  display: inline-block;
  margin-top: 4px;
  margin-bottom: 20px;
  cursor: pointer;
  color: ${props => props.viewProductsTextColor};
  .prod-det__text {
    font-size: ${props => props.viewProductsFontSize}px;
    font-weight: ${props => props.viewProductsFontWeight};
    font-style: ${props => props.viewProductsFontStyle};
    text-decoration: ${props => props.viewProductsTextDecoration};
    @media (max-width: 425px) {
      font-size: ${props => props.viewProductsMobileFontSize}px;
    }
  }
  .prod-det__img {
    height: 8px;
    width: auto;
    margin-left: 4px;
    vertical-align: baseline;
    fill: none;
  }
`;

export const Overlay = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  display: none;
  justify-content: center;
  align-items: center;
  background: #f9f9f9;
  pointer-events: none;
  font-size: 12px;
  letter-spacing: 1px;
  img {
    width: 9px;
    height: auto;
    margin-left: 4px;
  }
`;

export const ProductCon = styled.div`
  display: flex;
  gap: 12px;
`;

export const ProductImgCon = styled.div`
  display: inline-flex;

  #Gpic1 {
    width: ${props => props.productImageWidth}px;
    height: ${props => props.productImageHeight}px;
    @media (max-width: 425px) {
      width: ${props => props.productImageMobileWidth}px;
      height: ${props => props.productImageMobileHeight}px;
    }
  }

  .sliderImg {
    ${props =>
      props.isProductImageBordered
        ? `
    border: ${props.productImageBorderWidth}px solid ${
            props.productImageBorderColor
          };`
        : ''};

    width: ${props => props.productImageWidth}px;
    height: ${props => props.productImageHeight}px;
    border-radius: ${props => props.productImageBorderRadius}px;
    object-fit: cover;
    @media (max-width: 425px) {
      width: ${props => props.productImageMobileWidth}px;
      height: ${props => props.productImageMobileHeight}px;
      border-radius: ${props => props.productImageMobileBorderRadius}px;
    }
`;

export const ProductDescCon = styled.div`
  display: inline-flex;
  padding-left: 0em !important;
`;

export const AddedToCardMsgCon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 4.3px 5px;
  color: ${props => props.textColor};
  min-height: ${props => props.minHeight}px;
  font-size: ${props => props.fontSize}px;
  font-style: ${props => props.fontStyle};
  font-weight: ${props => props.fontWeight};
  text-decoration: ${props => props.textDecoration};
  @media (max-width: 425px) {
    font-size: ${props => props.$mobileFontSize}px;
  }
`;
